var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKickOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "425.000000pt",
    height: "425.000000pt",
    viewBox: "0 0 425.000000 425.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,425.000000) scale(0.100000,-0.100000)",
    fill: "#ec2d05",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455 3793 c-247 -250 -452 -465 -453 -476 -3 -15 137 -161 590 -614 l593 -593 -590 -590 c-325 -324 -592 -595 -593 -600 -5 -15 906 -914 931 -918 15 -3 163 140 603 580 321 320 588 583 593 583 4 0 257 -246 562 -546 559 -550 630 -619 644 -619 14 0 910 912 913 930 2 11 -101 119 -305 321 -695 686 -873 864 -871 870 2 4 251 258 554 565 555 563 624 635 624 649 0 14 -912 910 -930 913 -11 2 -122 -104 -321 -305 -167 -169 -433 -438 -591 -598 l-288 -290 -597 598 c-329 328 -603 597 -608 597 -6 -1 -212 -206 -460 -457z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickOut);
export default __webpack_public_path__ + "static/media/kickOut.21d1dbe8abf7c8679afacab05c3b3f3e.svg";
export { ForwardRef as ReactComponent };